import { Component, Inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";

export interface CampaignPartnersInviteConfirmDialogData {
  readonly errors: number;
  readonly multipleSelections: number;
  readonly alreadyJoined: number;
  readonly skipped: number;
  readonly toImport: number;
}

export type CampaignPartnersInviteConfirmDialogResult = boolean;

@Component({
  selector: "app-campaign-partners-edit-invite-dialog",
  templateUrl: "./campaign-partners-invite-confirm-dialog.component.html",
  styleUrls: ["./campaign-partners-invite-confirm-dialog.component.scss"],
})
export class CampaignPartnersInviteConfirmDialogComponent {
  constructor(
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA)
    public data: CampaignPartnersInviteConfirmDialogData,
    private readonly dialogRef: MatDialogRef<CampaignPartnersInviteConfirmDialogComponent>,
  ) {}

  public continue(): void {
    this.dialogRef.close(true);
  }
}
